export type Locales =
  | "sa-en"
  | "sa-ar"
  | "ae-en"
  | "ae-ar"
  | "qa-en"
  | "qa-ar"
  | "kw-en"
  | "kw-ar"
  | "eg-en"
  | "eg-ar";

export const locales: Readonly<Locales[]> = [
  "sa-en",
  "sa-ar",
  "ae-en",
  "ae-ar",
  // "qa-en",
  // "qa-ar",
  // "kw-en",
  // "kw-ar",
  "eg-en",
  "eg-ar",
];

export const regions: {
  code: string;
  name: string;
  shortName: string;
  alpha3Code: string;
  flag: string;
}[] = [
  { code: "ae", alpha3Code: "uae", name: "United Arab Emirates", shortName: "UAE", flag: "🇦🇪" },
  { code: "sa", alpha3Code: "ksa", name: "Kingdom of Saudi Arabia", shortName: "KSA", flag: "🇸🇦" },
  // { code: "qa", alpha3Code: "qat", name: "Qatar", shortName: "Qatar", flag: "🇶🇦" },
  // { code: "kw", alpha3Code: "kwt", name: "Kuwait", shortName: "Kuwait", flag: "🇰🇼" },
  { code: "eg", alpha3Code: "egy", name: "Egypt", shortName: "Egypt", flag: "🇪🇬" },
];

export const languages: { code: string; name: string }[] = [
  { code: "en", name: "English" },
  { code: "ar", name: "العربية" },
];